import { all, takeLatest, call, put } from "redux-saga/effects";
import consts from "../../../consts"; // lembra de alterar
import {api} from "../../../services/api"; // falta conectar api
import types from "./types";
import { updateAgendamento } from "./actions";

export function* filterAgendamento({ start, end }) {
  try {//resolver problemas na api fake
    const { data: res } = yield call(api.post, "/agendamentos", {
      id: consts.id,
      start: start,
      end: end,
    });
    
    if (res.error) {
      alert(res.message + "Sou um error em saga");
      return false;
    }


    yield put(updateAgendamento(res.agendamentos));
    
  } catch (error) {
    alert(error.message);
    return false;
  }
}

export default all([takeLatest(types.FILTER_AGENDAMENTOS, filterAgendamento)]);
